import React from 'react';

import { LinearProgress } from '@mui/material';

import CabinFormsDataGrid from '../../components/CabinFormsDataGrid';
import { EventFormStatus, ReportType } from '../../core/api/clients';
import useGetEventReportsByType from '../../core/api/hooks/event-report/useGetEventReportsByType';

interface IDispatchEventSubmissions {
  hours?: number;
  statuses?: EventFormStatus[];
  isOwner?: boolean;
  pageSize?: number;
  readonly?: boolean;
}

function DispatchEventList({ hours = 0, statuses = [], isOwner = false, pageSize = 25, readonly = false }: IDispatchEventSubmissions): JSX.Element {
  const reports = useGetEventReportsByType({
    reportType: ReportType.DispatchEventReport,
    hours,
    statuses,
    isOwner,
  });
  if (reports?.isLoading) {
    return (
      <LinearProgress />
    );
  }

  return (
    <CabinFormsDataGrid
      data={reports}
      reportType="dispatch-event"
      areSubmissions
      pageSize={pageSize}
    />
  );
}

export default DispatchEventList;
